const TEALIUM_ASYNC_SCRIPT_ID = 'tealium_async';

const tealiumScriptUrls = {
  DEV: 'https://tags.tiqcdn.com/utag/asics/main/dev/utag.js',
  STG: 'https://tags.tiqcdn.com/utag/asics/main/stg/utag.js',
  PRD: 'https://tags.tiqcdn.com/utag/asics/main/prod/utag.js',
};

if (typeof window !== 'undefined') {
  if (!document.getElementById(TEALIUM_ASYNC_SCRIPT_ID) || !window.utag) {
    // Disables automatic page tracking, must be set before loading Tealium script
    window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
    window.utag_cfg_ovrd.noview = true;
    // commenting out the below to fix sitename issue used in tealium.
    // window.utag_data = {};

    const tealiumAsyncScript = document.createElement('script');
    const tealiumScriptUrl = process.configs?.TARGET_ENV ?
      tealiumScriptUrls[process.configs?.TARGET_ENV] :
      tealiumScriptUrls.DEV;
    tealiumAsyncScript.setAttribute('type', 'text/javascript');
    tealiumAsyncScript.setAttribute('async', 'true');
    tealiumAsyncScript.setAttribute('id', TEALIUM_ASYNC_SCRIPT_ID);
    tealiumAsyncScript.setAttribute('src', tealiumScriptUrl);
    document.head.appendChild(tealiumAsyncScript);
  }
}

export const logTealiumAnalytics = ({
  gaEventAction,
  gaEventCategory,
  gaEventLabel,
  gaEventNonInteraction,
  sf2_colors,
  sf2_experience_id,
  sf2_feel,
  sf2_product_rec,
  sf2_pronation,
  sf2_question_number,
  sf2_section_label,
  sf2_section_number,
  sf2_size_width,
}) => {

  if (window.utag && gaEventAction) {
    window.utag.link({
      gaEventAction,
      gaEventCategory,
      gaEventLabel,
      gaEventNonInteraction,
      sf2_colors,
      sf2_experience_id,
      sf2_feel,
      sf2_pronation,
      sf2_persona: '',
      sf2_product_rec,
      sf2_question_number,
      sf2_section_label,
      sf2_section_number,
      sf2_size_width,
    });
  }
};
